import { rm } from 'utils';
import { StyledButton } from './notifyMe.styles';
import { Spinner } from '@bygghemmait/components';

type NotifyMeButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
};

export const NotifyMeButton = ({ onClick, disabled }: NotifyMeButtonProps) => (
  <StyledButton appearance="whitePill" onClick={onClick} type="submit" disabled={disabled}>
    {rm('notify-me-button')}
  </StyledButton>
);

type LoaderButtonProps = {
  isLoading: boolean;
} & NotifyMeButtonProps;

export const LoaderButton = ({ onClick, isLoading, disabled }: LoaderButtonProps) => {
  if (isLoading) {
    return (
      <StyledButton appearance="whitePill" disabled>
        <Spinner size={6} $thickness={2} />
      </StyledButton>
    );
  }
  return <NotifyMeButton onClick={onClick} disabled={disabled} />;
};
